import React from "react";
import {findDOMNode} from "react-dom";


// @ts-ignore
import EstimatePickerPopover from "../../../../../../core/gd-ui/select-estimate/popover/ui5/popover-ui5";

export default function FieldEstimate_Popover(props:any) {

    const {hours, minutes} = gd.utils.minutesToHM(props.value);

    return (
        <EstimatePickerPopover hours={hours}
                               minutes={minutes}
                               attachment="top center"
                               targetAttachment="bottom center"
                               getTargetFunc={()=>findDOMNode(props.parent)}
                               onClickOutside={()=>{props.parent.hidePopover()}}
                               onSave={props.parent.onValueChange}/>
    )
}
